import { ReactElement, useEffect, useState } from 'react';
import { IMeetingModalProps } from '.';
import QRCode from 'react-qr-code';
import WhereToScan from '@assets/images/where-scan.png';
import { ANNUAL_MEETS_GROUP_B, BIG_MEETS } from '@config/constant';

export const MeetingQrModal = (props: IMeetingModalProps): ReactElement => {
	const { dataObject } = props;
	const isBigMeetingType = (meetingType: string): boolean => {
		const type = meetingType?.toLowerCase();
		return BIG_MEETS.includes(type);
	};

	const isAnnualMeetGroupB = (meetingType: string): boolean => {
		const annualMeetGroupB = meetingType;
		return ANNUAL_MEETS_GROUP_B.includes(annualMeetGroupB);
	};

	const [qrValue, setQrValue] = useState<string>(() => {
		if (!dataObject?.sfid) return '';
		const endDate = new Date(dataObject?.enddate);
		endDate.setHours(23, 59, 59);
		const endTimestampInSeconds = Math.floor(endDate.getTime() / 1000);

		return isBigMeetingType(dataObject.meeting_type_c ?? '') || isAnnualMeetGroupB(dataObject.meeting_type_c ?? '')
			? `${dataObject?.sfid}_${endTimestampInSeconds}`
			: `${dataObject.sfid}_${Math.floor(Date.now() / 1000)}`;
	});

	useEffect(() => {
		if (
			dataObject?.meeting_type_c &&
			(isBigMeetingType(dataObject?.meeting_type_c) || isAnnualMeetGroupB(dataObject?.meeting_type_c ?? ''))
		) {
			const endDate = new Date(dataObject?.enddate);
			endDate.setHours(23, 59, 59);
			const endTimestampInSeconds = Math.floor(endDate.getTime() / 1000);

			setQrValue(`${dataObject?.sfid}_${endTimestampInSeconds}`);
			return;
		}

		if (!isBigMeetingType(dataObject?.meeting_type_c ?? '')) {
			const getUtcTimestamp = (): number => Math.floor(Date.now() / 1000);

			setQrValue(`${dataObject?.sfid}_${getUtcTimestamp()}`);
			const interval = setInterval(() => {
				setQrValue(`${dataObject?.sfid}_${getUtcTimestamp()}`);
			}, 5000);

			return (): void => clearInterval(interval);
		}
	}, [dataObject?.sfid, dataObject?.meeting_type_c, dataObject?.enddate]);

	return (
		<div className="about-pop-content">
			<div className="top-content">
				<div className="qr-code-image">
					{dataObject?.sfid && <QRCode value={qrValue} size={200} style={{ height: '200px' }} />}
				</div>

				<span className="h3 fcc-title">{dataObject?.name}</span>

				<p className="date-time">{dataObject?.startdate}</p>

				<div className="divider"></div>
			</div>

			<div className="bottom-content">
				<span className="qs-scan">whare to scan?</span>

				<div className="whare-to-scan">
					<img src={WhereToScan} alt="whare to scan" title="whare to scan" height="210" width="190" />
				</div>
			</div>
		</div>
	);
};
